export const ds_NewsletterListingBlock_Entry = `
    fragment ds_NewsletterListingBlock_Entry on ds_NewsletterListingBlock_Entry {
        id
        canonicalUid

        newsletterListing_TopSpacing
        newsletterListing_FullWidthBackground
        newsletterListing_ContainerWidth
        newsletterListing_ColorTheme
        newsletterListing_ColorPalette

        newsletterListing_Heading

        newsletterListing_Category {
            id
            slug
        }
    }
`